import { logUsage } from 'owa-analytics';
import type { CustomDataMap } from 'owa-analytics-types';
import type { MailboxInfo } from 'owa-client-types';
/**
 * Logs telemetry for smart alert item switch events during compose on-send scenarios.
 *
 * Sample Event:
 *  {
 *      "hostItemIndex": "PRIVATE",
 *      "userClickedButton": "Wait",
 *  }
 * @param smartAlertItemSwitchTelemetryData - Custom data map containing event details
 * @param mailboxInfo - The mailbox info from the compose view state (DCM for the draft being composed)
 */
export function logSmartAlertItemSwitchTelemetryEvent(
    smartAlertItemSwitchTelemetryData: CustomDataMap,
    mailboxInfo: MailboxInfo
): void {
    logUsage('SmartAlertItemSwitchEvent', mailboxInfo, {
        ...smartAlertItemSwitchTelemetryData,
    });
}
